export const MIN_ORDER_PRICE = 500;
export const MIN_ORDER_FREE_DELIVERY = 2000;
export const DELIVERY_PRICE = 290;
